/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index popover to autogenerate all the components and extensions
 * Used by "preparePopovers"
 */

import Popover from './popover/Popover'
export * from './popover/Popover'
export default Popover
